import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastComponent=()=>{
  return ( 
      <ToastContainer />    
  );
}

export default ToastComponent;